import React, { useMemo } from 'react';
import CardTable from '../CardTable';
import { formatDate, formatRate } from '../format';
import styles from '../card.module.css';

/* Вкладка «Штат» (п. 10 ТЗ). Только просмотр: кнопок, изменяющих штат, нет.

   Порядок строк — как пришёл с сервера (сервер сортирует по «Должность»).
   Позиции с замещением выводятся деревом: строка-замещение (is_child) идёт сразу
   за своей основной позицией (main_cpid = cpid родителя) со сдвигом.
   Явно ошибочные значения («2323», «641448») выводятся как есть. */

const COLUMNS = [
  { key: 'code', title: 'Код', cell: row => row.code, className: styles.mono },
  { key: 'position', title: 'Должность', cell: row => row.position, className: styles.lead },
  { key: 'indicator', title: <>Признак<br />должности</>, cell: row => row.position_indicator },
  { key: 'tariff', title: 'Разряд', cell: row => row.tariff, className: styles.mono },
  { key: 'level', title: 'Уровень', cell: row => row.level },
  { key: 'rank', title: 'Звание', cell: row => row.rank },
  { key: 'vus', title: 'ВУС', cell: row => row.vus },
  { key: 'employment', title: <>Вид<br />занятости</>, cell: row => row.employment_type },
  { key: 'rate', title: 'Ставка', cell: row => formatRate(row.rate), className: styles.mono },
  { key: 'employee', title: 'Сотрудник', cell: row => (row.is_vacant ? 'Нет' : row.employee) },
  { key: 'date', title: 'Дата', cell: row => formatDate(row.assign_date), className: styles.mono },
  {
    key: 'deputy',
    title: 'Замещение',
    cell: row => row.deputy,
    tdTitle: row => row.deputy,
  },
  {
    key: 'track',
    title: <>Отслеживать<br />ППК</>,
    cell: row => (row.track_qualify_update ? 'Да' : 'Нет'),
  },
];

// родители в порядке сервера, после каждого — его строки-замещения
const buildTree = (items) => {
  const parents = items.filter(row => !row.is_child);
  const childrenBy = {};
  items.filter(row => row.is_child).forEach((row) => {
    (childrenBy[row.main_cpid] = childrenBy[row.main_cpid] || []).push(row);
  });
  const ordered = [];
  const placed = new Set();
  parents.forEach((parent) => {
    ordered.push(parent);
    (childrenBy[parent.cpid] || []).forEach((child) => {
      ordered.push({ ...child, __childClass: styles.childRow });
      placed.add(child.cpid);
    });
  });
  // строки-замещения без найденного родителя не теряем
  items.filter(row => row.is_child && !placed.has(row.cpid))
    .forEach(row => ordered.push({ ...row, __childClass: styles.childRow }));
  return ordered;
};

const Personnel = ({ data }) => {
  const rows = useMemo(() => buildTree(data.items || []), [data.items]);

  return (
    <CardTable
      columns={COLUMNS}
      rows={rows}
      nowrap
      rowKey={(row, index) => (row.cpid != null ? `${row.cpid}-${index}` : index)}
      counter={(
        <>Всего записей: <b>{data.count}</b> · вакантных: <b>{data.vacancy_count}</b></>
      )}
      emptyTitle="Штатных позиций нет"
      emptyText="За кафедрой не заведено ни одной штатной единицы"
    />
  );
};

export default Personnel;
